import { Box } from "@radix-ui/themes";
import { Outlet } from "react-router-dom";
import { LastClickedOrderProvider } from "../lib/last-clicked-order-provider";
import Header from "@/shared/components/header";
import { NavigationItems } from "@/shared/types/navigation";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";

export function DashboardLayout() {
  useDocumentTitle(NavigationItems.LAD.name);

  return (
    <div>
      <Header
        hasWarning
        title={NavigationItems.LAD.name}
        exclude={[NavigationItems.LAD.id]}
      />

      <LastClickedOrderProvider>
        <Box p="3">
          <Outlet />
        </Box>
      </LastClickedOrderProvider>
    </div>
  );
}
